import React from 'react';
import { MusicIcon } from 'lucide-react';
export function CountdownBar() {
  return <div className="w-full bg-navy text-white" data-id="element-66" data-mp="30621bch8yeu5">
      <div className="mx-auto flex h-11 max-w-6xl items-center justify-center gap-2 px-4 text-center sm:h-12" data-id="element-67" data-mp="306bpqvmn8dxq">
        <p className="flex items-center gap-2 text-[10px] font-extrabold uppercase tracking-[0.08em] sm:text-xs sm:tracking-[0.14em]" data-id="element-68" data-mp="2vd8ria6x8gb7">
          <MusicIcon className="h-3.5 w-3.5 flex-none text-orange" aria-hidden="true" data-id="element-69" data-mp="2me3ytki1jh6y" />
          Il curricolo musicale completo per la scuola italiana
        </p>
      </div>
    </div>;
}